



































































































import _ from 'lodash';
import moment from 'moment';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { StoreType } from '@/enums';
import { dateService, numeralService } from '@/services';

@Component({
  validations: {
    branchs: {
      $each: {
        percentRate: {
          minValue: ((value: any, field: any) => {
            return field.idStoreTypeClientFuture === StoreType['3S'] ? +value > 0 : true;
          })
        },
        percentDivision: {
          minValue: ((value: any, field: any) => {
            return field.idStoreTypeClientFuture === StoreType['3S'] ? +value > -1 : true;
          })
        },
        dateConversion: {
          minValue: ((value: any, field: any) => {
            return field.idStoreTypeClientFuture === StoreType['3S'] ? +value > +moment().startOf('month').subtract(1, 'month').toDate() : true;
          })
        }
      }
    }
  }
})
export default class WizardStoreConvert extends Vue {
  $v: any;
  @Prop({ default: false }) open: boolean;
  @Prop({ required: true }) store: any;
  public parseToMoment = dateService.parseToMoment;
  public parseDateToString = dateService.parseDateToString;
  public parseStringToDate = dateService.parseStringToDate;

  public finalStoreTypeClientId = StoreType['3S'];

  public storeTypeDataSource = [{
    text: '2S',
    value: StoreType['2S']
  }, {
    text: '3S',
    value: StoreType['3S']
  }];

  public get branchs () {
    return _.filter(this.store.branchs, (b: any, i: number) => i > 0);
  }

  public updateInputNumber (event: any, type: string, index: number) {
    if (type === 'dateConversion') {
      (this.branchs as any)[index][type] = dateService.parseToMoment(event.target.value, 'MM/YYYY').startOf('month').toDate() as any;
    } else {
      (this.branchs as any)[index][type] = (Math.round(numeralService.parseToNumber(event.target.value) * 100) / 100) || 0;
    }
    this.$v.branchs.$each[index][type].$touch();
    this.updateFormStatus();
  }

  public resetInputFields (branch: any) {
    branch.percentDivision = null;
    branch.percentRate = null;
    branch.dateConversion = null;

    this.updateFormStatus();
  }

  public updateFormStatus () {
    this.$v.$touch();
  }

  @Emit('submit')
  onSubmit () {} // tslint:disable-line

  @Emit('cancel')
  onCancel () {} // tslint:disable-line
}
